import { createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import useFetchAemBrspdContents from "../../../../../shared/hooks/useFetchAemBrspdContents";
import ApiUrls from "../../../Utils/axr";
import { errorConditionGTM } from "../../../Utils/googleTags";

type PostpaidFiberContentState = {
    postpaidFiberContent: any;
    loading: boolean;
    error: any;
}

const initialState: PostpaidFiberContentState = {
    postpaidFiberContent: null,
    loading: false,
    error: null,
};

const host = window?.location?.host;
const file = "postpaid-fiber.json";

export const getPostpaidFiberContent = createAsyncThunk(
    "get/postpaid-fiber/content",
    async () => {
        try {
            const response = await useFetchAemBrspdContents({
                [ApiUrls.aem_content]: `${file}?appName=${host}`,
            });
            return response?.data;
        } catch (error) {
            throw error;
        }
    }
);

const postpaidFiberSlice = createSlice({
    name: "postpaid-fiber-content/Details",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getPostpaidFiberContent.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(getPostpaidFiberContent.fulfilled, (state, action) => {
            state.postpaidFiberContent = action.payload;
            state.loading = false;
            state.error = null;
        })
        builder.addCase(getPostpaidFiberContent.rejected, (state, action) => {
            errorConditionGTM(
                "BRSPD_Fiber_EC_Flow",
                "postpaid-fiber-content",
                action?.error?.message,
                action?.type
            );
            state.postpaidFiberContent = null;
            state.loading = false;
            state.error = action.error;
        });
    },
});

export default postpaidFiberSlice.reducer;